<template>
    <div class="body">
      <div class="header">
        <el-form :model="SelectOrderManagementDTO" :inline="true">
          <el-form-item label="上传日期">
            <el-date-picker
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>
          
          <el-form-item label="客户名称">
              <el-input
                v-model="SelectOrderManagementDTO.customerName"
                placeholder="客户名称"
              ></el-input>
            </el-form-item>

   
            <el-button class="btn-style btn-search"  type="primary" @click="serchInfo">
              搜索
            </el-button>
            <el-button class="btn-style btn-buy"  type="primary" @click="submit">
              显示未结清
            </el-button>
            <br>
          <el-form-item>
          </el-form-item>
        </el-form>
        <el-dialog
        text-align: center
        :close-on-click-modal="false"
        title="新增特殊工艺设置"
        :visible.sync="drawer"
        width="25%"
      >
        <el-form
          ref="accountForm"
          :rules="rules"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >

 
    <el-form-item  label="名称" prop="name">
          <el-input
            class="input-remark"
            
            v-model="accountForm.name"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
 
        <el-form-item  label="单价" prop="price">
          <el-input
            class="input-remark"
            
            v-model="accountForm.price"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
          <el-form-item >
            <el-button
              
              type="primary"
              @click="submitForm('accountForm')"
            >
              立即创建
            </el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
        <div style="display: flex">
          
          <!-- <el-button
            
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <el-dialog title="计件详情" :visible.sync="dialogVisible"  width="60%" :close-on-click-modal="false">
        <el-form
          ref="accountForm"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >
        <div style="text-align: center;">
        <el-button class="btn-style btn-buy"   type="warning" @click="downLoadInfo" >
              导出
            </el-button>
          </div>
        <el-table
                        v-if="OrderInformationVO && OrderInformationVO.length"
                        :data="OrderInformationVO"
                        stripe
                        border
                        style="width: 100%"
              
                        class="OrderInformationVO"
                    >
                    
                    <el-table-column
                            prop="orderName"
                            align="center"
                            label="订单名称"
                        ></el-table-column>
                    <el-table-column
                            prop="category"
                            align="center"
                            label="产品名称"
                        ></el-table-column>
                        <el-table-column
                            prop="num"
                            align="center"
                            label="数量"
                        ></el-table-column>
                        <el-table-column
                            prop="listPrice"
                            align="center"
                            label="单价"
                        ></el-table-column>
                        <el-table-column
                            prop="subclass"
                            align="center"
                            label="产品类别"
                        ></el-table-column>
                        <el-table-column
                            prop="processRequirements"
                            align="center"
                            label="工艺要求"
                        ></el-table-column>
                        <el-table-column
                            prop="remarks"
                            align="center"
                            label="备注"
                        ></el-table-column>
                        <el-table-column
                            prop="thumbnailPath"
                            label="缩略图"
                            align="center"
                            width="200">
                            <template slot-scope="scope">
                                <el-popover placement="top-start" trigger="click">
                                    <a :href="scope.row.thumbnailPath" target="_blank" title="查看最大化图片">
                                        <img :src="scope.row.thumbnailPath" style="max-height: 800px;max-width: 800px">
                                    </a>
                                    <img slot="reference" :src="scope.row.thumbnailPath"
                                         style="max-height: 50px;max-width: 50px cursor:pointer">
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="createTime"
                            align="center"
                            label="上传时间"
                        ></el-table-column>
                        <el-table-column
                            prop="unit"
                            align="center"
                            label="单位"
                        ></el-table-column>
                        <el-table-column
                            prop="specifications"
                            align="center"
                            label="规格"
                        ></el-table-column>
        </el-table>
          <el-button  @click="dialogVisible = false">取 消</el-button>
        </el-form>
      </el-dialog>
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
        <el-table-column
            prop="customerName"
            align="center"
            label="客户名称"
          ></el-table-column>
          <el-table-column
            prop="orderAmounts"
            align="center"
            label="订单总金额"
          ></el-table-column>
 
          <el-table-column
            prop="paid"
            align="center"
            label="已付款"
          ></el-table-column>
          <el-table-column
            prop="preferentialAmount"
            align="center"
            label="优惠金额"
          ></el-table-column>
          <el-table-column
            prop="unpaids"
            align="center"
            label="待付款"
          ></el-table-column>
          <el-table-column
          prop="paymentStatus"
          align="center"
          label="付款状态"
        >     <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.paymentStatus==='0'">未结清</el-tag>
          <el-tag type="success" v-if="scope.row.paymentStatus==='1'">已结清</el-tag>
      </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="280">
          <template v-slot="{ row }">
            <el-link type="success"  @click="handleEdit(row)">详情</el-link>
          </template>
        </el-table-column>
        </el-table>
      </div>
  

    </div>
  </template>
  
  <script>
  import { selectAmountByCustomer,selectAmountByCustomerInfo,downLoadAmountByCustomerInfo} from '@/api/order/reconciliation.js'
  import { exportExcel } from '../../utils/index'
  export default {
    data() {
      return {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        ids: '',
        OrderInformationVO:[],
        cellClassName: {
          shortcuts: [
          {
              text: '最近一天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]
  
        },
        paymentStatus: [{
          value: '0',
          label: '未结清'
        }, {
          value: '1',
          label: '已结清'
        }],
        date: '',
        conTract: [],
        SelectOrderManagementDTO:{
          access:'',
            startTime: '',
            endTime: '',
            category: '',
            productionProcesses:''
        },
        category:[],
        drawer: false,
        dialogVisible:false,
        accountForm:{
          id:'',
          access:'',
          name:'',
          price:'',
        },
        SelectByCustomer:{
          startTime:'',
          endTime:'',
          access:'',
          customerName:''
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        },
        rules:{
          name:[
                    { required: true, message: '请输入名称', trigger: 'blur' }]
           
            }

      }
    },
    
  
    mounted() {
      this.SelectOrderManagementDTO.access=localStorage.getItem("access")
      this.accountForm.access=localStorage.getItem("access")
      this.SelectByCustomer.access=localStorage.getItem("access")
      this.getTableData() // 进入页面调用一次获取数据的方法
    },
    methods: {
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },

      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getTableData()
      },
      submit(){
          this.SelectOrderManagementDTO.paymentStatus='0'
          this.getTableData()
      },
      downLoadInfo(){
        downLoadAmountByCustomerInfo(this.SelectByCustomer)
          .then((res) => {
            if (res.status === 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      handleEdit(row) {
        console.log(row)
        this.SelectByCustomer.customerName=row.customerName
        selectAmountByCustomerInfo(this.SelectByCustomer).then((res) => {
         this.OrderInformationVO = res.data.data
        })
        this.dialogVisible = true
      },
      getTableData() {
        selectAmountByCustomer(this.currentPage, this.pageSize, this.SelectOrderManagementDTO).then((res) => {
            console.log(res);
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
      },
     
     
     
    
      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },
  
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.SelectOrderManagementDTO.startTime = e[0]
          this.SelectOrderManagementDTO.endTime = e[1]
        } else if (!e) {
          this.SelectOrderManagementDTO.startTime = ''
          this.SelectOrderManagementDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.SelectOrderManagementDTO.paymentStatus=''
        this.getTableData()
      },
      categorySelect(e) {
                if(e.target.value) { 
                    this.accountForm.category = e.target.value
            }
        },
        
   
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
  }
  .body {
    overflow: auto;
  }
  
  .pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
  }
  .el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
  }
  .el-date-editor , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
      border-radius: 8px;
  }
  ::v-deep.el-table thead th{
      background: #EAF4F0;
      color: var(--secondColor);
  }
  .btn-style{
      border-radius: 8px;
  }
  .btn-search{
      background: var(--theme-color);
  }
  .btn-download , .btn-confirm{
      background: #4093FF;
  }
  .btn-redownload , .btn-cancel{
      background: #FF8429;
  }
  .btn-delete{
      background: #FF4D4D;
  }
  .btn-buy{
    background: #FF8429;
}
  </style>
  